import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-worlds',
  templateUrl: './worlds.component.html',
  styleUrls: ['./worlds.component.scss']
})
export class WorldsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
